<script lang="ts">
  import { Button as ButtonPrimitive } from 'bits-ui';
  import { Info, PlusCircle, Undo2, ExternalLink } from 'lucide-svelte';
  import { Loader2 } from 'lucide-svelte';
  import { type Events, type Props, buttonVariants } from './index.js';
  import { cn } from '$lib/utils.js';

  type $$Props = Props;
  type $$Events = Events;

  let className: $$Props['class'] = undefined;
  export let variant: $$Props['variant'] = 'default';
  export let size: $$Props['size'] = 'default';
  export let builders: $$Props['builders'] = [];
  export let loading: $$Props['loading'] = false;
  export let icon: $$Props['icon'] = undefined;
  export let enableBlinker: $$Props['enableBlinker'] = undefined;
  export { className as class };

  const iconMapper = {
    add: PlusCircle,
    back: Undo2,
    info: Info,
    external: ExternalLink
  };
</script>

<ButtonPrimitive.Root
  {builders}
  class={cn(buttonVariants({ variant, size, className }), 'relative')}
  type="button"
  {...$$restProps}
  on:click
  on:keydown
>
  {#if loading}
    <Loader2
      class={cn(
        {
          'mr-2': $$slots.default
        },
        'h-4 w-4 animate-spin'
      )}
    />
  {:else if icon}
    <svelte:component
      this={iconMapper[icon]}
      class={cn('h-4 w-4', {
        'mr-2': $$slots.default
      })}
    />
  {/if}
  <slot />
  {#if enableBlinker}
    <span class="absolute flex h-4 w-4 top-1/2 left-0 translate-x-1/2 -translate-y-1/2">
      <span
        class={cn('animate-ping inline-flex h-full w-full rounded-full opacity-75', {
          'text-white bg-white': variant === 'default',
          'text-primary bg-primary':
            variant === 'outline' || variant === 'secondary' || variant === 'ghost'
        })}
      />
    </span>
  {/if}
</ButtonPrimitive.Root>
